module.exports = __webpack_public_path__ + "static/media/flologo.30324d9b.svg";